export class UnsetGradingSchemeFromModule {
    static readonly type = '[GradingScheme] UnsetGradingSchemeFromModule';

    constructor(
        public payload: {
            moduleId: string;
        }
    ) {}
}
